"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9526],{

/***/ 91841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    contentClassName: "",
    swapTextAndAssetPosition: false,
    leftSizeWidth: null,
    rightSizeWidth: null,
    background: {},
    fullParagraph: segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__.AUTO,
    withDynamicParagraphTitle: false,
    withDynamicParagraphSubtitle: false
});


/***/ }),

/***/ 59526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13211);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(861);
/* harmony import */ var _components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24961);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65488);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65023);
/* harmony import */ var _side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99024);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91841);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var FULL_WIDTH = "100%";
var SideBySideTextAndAsset = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(SideBySideTextAndAsset, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(SideBySideTextAndAsset);
    function SideBySideTextAndAsset() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, SideBySideTextAndAsset);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "assetExist", function(asset) {
            var _asset_image, _asset_video;
            return (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "onVideoStart", function() {
            var _asset_video_src_formats, _asset_video_src, _asset_video;
            var asset = _this.props.asset;
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.ASSET_COMPONENT_VIDEO_STARTED, {
                info1: asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : (_asset_video_src = _asset_video.src) === null || _asset_video_src === void 0 ? void 0 : (_asset_video_src_formats = _asset_video_src.formats) === null || _asset_video_src_formats === void 0 ? void 0 : _asset_video_src_formats[0]
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "renderAsset", function(asset) {
            var _props = _this.props, ReplaceAssetComponent = _props.replaceAssetComponent, replaceAssetComponentProps = _props.replaceAssetComponentProps, assetQuality = _props.assetQuality, useDynamicAsset = _props.useDynamicAsset, hideControls = _props.hideControls, useWindowMask = _props.useWindowMask, dynamicAssetParamPath = _props.dynamicAssetParamPath;
            if (ReplaceAssetComponent) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceAssetComponent, _object_spread({}, replaceAssetComponentProps));
            }
            var fitToContainer = asset.fitToContainer, assetHeight = asset.assetHeight, assetRestProps = _object_without_properties(asset, [
                "fitToContainer",
                "assetHeight"
            ]);
            var assetClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-asset", {
                "ignore-parent-height": !fitToContainer
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, assetRestProps), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                dynamicAssetParamPath: dynamicAssetParamPath,
                convertGifToVideo: true,
                className: assetClassName,
                imageClassName: "text-and-asset-image",
                style: {
                    height: assetHeight
                },
                onStart: _this.onVideoStart
            }));
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getFullParagraphComponentStyle", function() {
            var _props = _this.props, leftSizeWidth = _props.leftSizeWidth, nestedBoardItems = _props.nestedBoardItems;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, fullParagraphMarginTop = ref.fullParagraphMarginTop, fullParagraphMarginBottom = ref.fullParagraphMarginBottom, fullParagraphDistanceFromTop = ref.fullParagraphDistanceFromTop, parallaxAsset = ref.parallaxAsset;
            var styleObj = {
                width: leftSizeWidth,
                marginTop: fullParagraphMarginTop,
                marginBottom: fullParagraphMarginBottom
            };
            if (_this.assetExist(parallaxAsset)) {
                styleObj = _object_spread_props(_object_spread({}, styleObj), {
                    top: fullParagraphDistanceFromTop
                });
            }
            return styleObj;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getImageWrapperStyle", function() {
            var _props = _this.props, rightSizeWidth = _props.rightSizeWidth, allowImageOverflow = _props.allowImageOverflow;
            var style = {
                width: rightSizeWidth
            };
            if (allowImageOverflow) {
                style = _object_spread_props(_object_spread({}, style), {
                    overflow: "visible"
                });
            }
            return style;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "openLiveBoardExperience", function() {
            var _props = _this.props, nestedBoardItems = _props.nestedBoardItems, openLiveBoard = _props.openLiveBoard;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, boardBannerText = ref.boardBannerText, embeddedBoardTitle = ref.embeddedBoardTitle, addSecondLiveBoardSignUpButton = ref.addSecondLiveBoardSignUpButton, liveBoardToolTipText = ref.liveBoardToolTipText;
            openLiveBoard({
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "imageClicked", function(index) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.LIVE_BOARD_PARALLAX_ASSET_CLICKED, {
                kind: index !== undefined ? index : null
            });
            _this.openLiveBoardExperience();
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getReplaceTextProps", function() {
            var _props = _this.props, bulletsConfig = _props.bulletsConfig, iconsConfig = _props.iconsConfig, titleSize = _props.titleSize, textSize = _props.textSize, spaceFromParagraph = _props.spaceFromParagraph, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, topicBottomMargin = _props.topicBottomMargin, buttonTopMargin = _props.buttonTopMargin;
            var replaceTextProps = {};
            if (bulletsConfig) replaceTextProps.bulletsConfig = bulletsConfig;
            if (iconsConfig) replaceTextProps.iconsConfig = iconsConfig;
            if (titleSize) replaceTextProps.titleSize = titleSize;
            if (textSize) replaceTextProps.textSize = textSize;
            if (spaceFromParagraph) replaceTextProps.spaceFromParagraph = spaceFromParagraph;
            if (withDynamicParagraphTitle) replaceTextProps.withDynamicParagraphTitle = withDynamicParagraphTitle;
            if (withDynamicParagraphSubtitle) replaceTextProps.withDynamicParagraphSubtitle = withDynamicParagraphSubtitle;
            if (topicBottomMargin) replaceTextProps.topicBottomMargin = topicBottomMargin;
            if (buttonTopMargin) replaceTextProps.buttonTopMargin = buttonTopMargin;
            return replaceTextProps;
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(SideBySideTextAndAsset, [
        {
            key: "getLeftSpaceStyle",
            value: function getLeftSpaceStyle() {
                var background = this.props.background;
                var color = background.color, width = background.width;
                if (!width) return {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                return _object_spread({}, themeStyles);
            }
        },
        {
            key: "getBackgroundStyle",
            value: function getBackgroundStyle() {
                var _props = this.props, background = _props.background, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset;
                var width = background.width, color = background.color, verticalPadding = background.verticalPadding;
                var backgroundStyle = verticalPadding ? {
                    paddingBottom: verticalPadding,
                    paddingTop: verticalPadding
                } : {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!width || !themeStyles) return backgroundStyle;
                var direction = swapTextAndAssetPosition ? "left" : "right";
                backgroundStyle = _object_spread_props(_object_spread({}, backgroundStyle), {
                    background: "linear-gradient(to ".concat(direction, ", ").concat(themeStyles.background, " ").concat(width, ", white 0)"),
                    color: themeStyles.color,
                    gap: spaceBetweenTextAndAsset
                });
                return backgroundStyle;
            }
        },
        {
            key: "getContentStyle",
            value: function getContentStyle() {
                var _props = this.props, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset, mobileSpaceBetweenTextAndAsset = _props.mobileSpaceBetweenTextAndAsset;
                var backgroundStyle = this.getBackgroundStyle();
                return _object_spread({
                    "--space-between-text-and-asset": spaceBetweenTextAndAsset,
                    "--mobile-space-between-text-and-asset": mobileSpaceBetweenTextAndAsset || 0
                }, backgroundStyle);
            }
        },
        {
            key: "getSideBySideComponentStyle",
            value: function getSideBySideComponentStyle() {
                var _background_backgroundImage;
                var background = this.props.background;
                var backgroundImage = background === null || background === void 0 ? void 0 : (_background_backgroundImage = background.backgroundImage) === null || _background_backgroundImage === void 0 ? void 0 : _background_backgroundImage.src;
                if (backgroundImage) {
                    var _background_backgroundImage1;
                    return {
                        background: "url(".concat(backgroundImage, ")"),
                        backgroundPosition: (background === null || background === void 0 ? void 0 : (_background_backgroundImage1 = background.backgroundImage) === null || _background_backgroundImage1 === void 0 ? void 0 : _background_backgroundImage1.backgroundPosition) || "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    };
                }
                return null;
            }
        },
        {
            key: "getRightSpaceStyle",
            value: function getRightSpaceStyle() {
                var background = this.props.background;
                var width = background.width, color = background.color;
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!themeStyles) return {};
                return {
                    backgroundColor: width === FULL_WIDTH ? themeStyles.background : undefined
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, replaceTextComponent = _props.replaceTextComponent, replaceTextComponentProps = _props.replaceTextComponentProps, contentClassName = _props.contentClassName, fullParagraph = _props.fullParagraph, asset = _props.asset, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = _props.mobileSwapTextAndAssetPosition, background = _props.background, alignToLogo = _props.alignToLogo, paragraphVerticalAlignment = _props.paragraphVerticalAlignment, alignImageToScreenEdge = _props.alignImageToScreenEdge, hideParagraph = _props.hideParagraph, nestedBoardItems = _props.nestedBoardItems;
                var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, addLiveBoardTextAndAsset = ref.addLiveBoardTextAndAsset, parallaxAsset = ref.parallaxAsset, gapBetweenAssets = ref.gapBetweenAssets;
                var parallaxAssetExists = this.assetExist(parallaxAsset);
                var leftSpaceStyle = swapTextAndAssetPosition ? this.getRightSpaceStyle() : this.getLeftSpaceStyle();
                var contentStyle = this.getContentStyle();
                var sideBySideComponentStyle = this.getSideBySideComponentStyle();
                var rightSpaceStyle = swapTextAndAssetPosition ? this.getLeftSpaceStyle() : this.getRightSpaceStyle();
                var ReplaceTextComponent = replaceTextComponent || segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP;
                var width = background.width;
                var isFullWidth = width === FULL_WIDTH;
                var renderImage = function(image, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("image-wrapper", asset === null || asset === void 0 ? void 0 : asset.position, (asset === null || asset === void 0 ? void 0 : asset.shadow) && "with-shadow", parallaxAssetExists && "inside-parallax"),
                        onClick: addLiveBoardTextAndAsset ? function() {
                            return _this.imageClicked(index);
                        } : null,
                        style: _this.getImageWrapperStyle(),
                        children: _this.renderAsset(image)
                    });
                };
                var assetsToRenderForParallax = [
                    asset,
                    parallaxAsset
                ];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__/* .StyledSideBySideTextAndAsset */ .I, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-text-and-asset", {
                        "align-image-to-screen-edge": alignImageToScreenEdge,
                        "is-swap": swapTextAndAssetPosition,
                        "is-mobile-swap": mobileSwapTextAndAssetPosition
                    }),
                    style: sideBySideComponentStyle,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "left-space",
                            style: leftSpaceStyle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-content", paragraphVerticalAlignment, contentClassName, {
                                "is-swap": swapTextAndAssetPosition,
                                "is-mobile-swap": mobileSwapTextAndAssetPosition,
                                "is-full-width": isFullWidth,
                                "align-to-logo": !!alignToLogo,
                                "no-text-component": hideParagraph,
                                "add-live-board-experience": addLiveBoardTextAndAsset
                            }),
                            style: contentStyle,
                            children: [
                                !hideParagraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("full-paragraph-component-wrapper", parallaxAssetExists && "sticky"),
                                    style: this.getFullParagraphComponentStyle(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceTextComponent, _object_spread_props(_object_spread({}, replaceTextComponentProps, fullParagraph, this.getReplaceTextProps()), {
                                        openLiveBoardExperience: addLiveBoardTextAndAsset ? this.openLiveBoardExperience : null
                                    }))
                                }),
                                parallaxAssetExists ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "parallax-wrapper",
                                    style: {
                                        gap: gapBetweenAssets
                                    },
                                    children: assetsToRenderForParallax.map(function(image, index) {
                                        return renderImage(image, index);
                                    })
                                }) : renderImage(asset)
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "right-space",
                            style: rightSpaceStyle
                        })
                    ]
                });
            }
        }
    ]);
    return SideBySideTextAndAsset;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAsset.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;


/***/ }),

/***/ 99024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ StyledSideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);
/* harmony import */ var segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72428);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73759);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__);




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADER_CONTENT_HORIZONTAL_PADDING */ .Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default().BODY_CONTENT_HORIZONTAL_PADDING), "px");
var StyledSideBySideTextAndAsset = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e43lgw60"
})("height:100%;display:flex;justify-content:center;.left-space{flex-grow:1;}.side-by-side-content{width:100%;padding:0 ", BODY_HORIZONTAL_PADDING, ";max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px;flex-grow:1;position:relative;display:flex;align-items:center;gap:var(--space-between-text-and-asset);&.top{align-items:flex-start;}&.center{align-items:center;}&.bottom{align-items:flex-end;}&.is-swap{flex-direction:row-reverse;.full-paragraph-component-wrapper{padding:0 0 0 60px;}}&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.image-wrapper{position:relative;z-index:1;width:50%;}.full-paragraph-component-wrapper{position:relative;z-index:1;width:50%;&.sticky{position:sticky;align-self:flex-start;}}.image-wrapper.inside-parallax{width:100%;}.full-paragraph-component-wrapper{padding:0 60px 0 0;}.image-wrapper{overflow:hidden;display:flex;align-items:center;justify-content:center;&.with-shadow{", (0,segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.getComponentShadow)(), '}&.top{align-self:flex-start;}&.center{align-self:center;}&.bottom{align-self:flex-end;}.side-by-side-asset{height:100%;width:100%;&.ignore-parent-height{height:auto;}.picture-component{width:100%;height:100%;display:block;&:before{content:"";display:inline-block;height:100%;vertical-align:middle;}}.text-and-asset-image{max-width:100%;max-height:100%;width:auto;height:auto;display:inline-block;vertical-align:middle;position:relative;left:50%;transform:translateX(-50%);}}}&.add-live-board-experience{.image-wrapper{cursor:pointer;}}}.right-space{flex-grow:1;}@media (min-width:', constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){&.align-image-to-screen-edge{.side-by-side-content{max-width:unset;&:not(.is-swap){padding-right:0;}&.is-swap{padding-left:0;}.image-wrapper{.side-by-side-asset{.text-and-asset-image{width:100%;}}}}&:not(.is-swap){.left-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}.right-space{display:none;}}&.is-swap{padding:0 96px 0 0;.left-space{display:none;}.right-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){.side-by-side-content,.side-by-side-content.is-swap{flex-direction:column;gap:var(--mobile-space-between-text-and-asset);&.is-mobile-swap{flex-direction:column-reverse;}&.is-full-width{padding-top:30px;padding-bottom:45px;}.full-paragraph-component-wrapper,.image-wrapper{width:100% !important;}.full-paragraph-component-wrapper{padding:0 60px 60px 60px;}.image-wrapper{height:initial;padding-bottom:16px;}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_QUERY_MAX_WIDTH_M */ .TI, "){.side-by-side-content{padding:0;}.side-by-side-content,.side-by-side-content.is-swap{.full-paragraph-component-wrapper{padding:0 32px 40px 32px;}.image-wrapper{padding-left:32px !important;padding-right:32px !important;}}}.parallax-wrapper{width:50%;display:flex;flex-direction:column;}");


/***/ })

}]);